var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewAttemptDotsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "new-attempt",
    clipPath: "url(#clip0_1170_90853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM11.2 8.8H8.8V11.2C8.8 11.64 8.44 12 8 12C7.56 12 7.2 11.64 7.2 11.2V8.8H4.8C4.36 8.8 4 8.44 4 8C4 7.56 4.36 7.2 4.8 7.2H7.2V4.8C7.2 4.36 7.56 4 8 4C8.44 4 8.8 4.36 8.8 4.8V7.2H11.2C11.64 7.2 12 7.56 12 8C12 8.44 11.64 8.8 11.2 8.8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_90853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAttemptDotsMenu);
export default __webpack_public_path__ + "static/media/NewAttemptDotsMenu.a2f35b2971341dffed936ea896ead268.svg";
export { ForwardRef as ReactComponent };